/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, {
  FunctionComponent,
  useRef,
  useState,
  useLayoutEffect,
  RefObject
} from 'react';
// import { useWindowSize } from 'react-use';
import Confetti from 'react-confetti';
import styled from '@emotion/styled';
import { APP_CFG } from '../appcfg';
import { randomRange } from '../utils/utils';
import { randomInt } from 'its-pages';

const StyledDiv = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`;

function drawRect(particle: any, ctx: CanvasRenderingContext2D) {
  if (!particle.newRan) {
    particle.w = randomRange(10, 3);
    particle.h = randomRange(3, 1);
    particle.newRan = true;
  }
  ctx.fillRect(-particle.w / 2, -particle.h / 2, particle.w, particle.h);
  ctx.closePath();
  ctx.restore();
}

function drawSquare(particle: any, ctx: CanvasRenderingContext2D) {
  if (!particle.newRan) {
    particle.s = randomRange(5, 3);
    particle.newRan = true;
  }
  ctx.fillRect(-particle.s / 2, -particle.s / 2, particle.s, particle.s);
  ctx.closePath();
  ctx.restore();
}

function drawCircle(particle: any, ctx: CanvasRenderingContext2D) {
  if (!particle.newRan) {
    particle.r = randomRange(5, 3);
    particle.newRan = true;
  }

  ctx.arc(0, 0, particle.r, 0, 2 * Math.PI);
  ctx.fill();
}

function drawTriangle(particle: any, ctx: CanvasRenderingContext2D) {
  if (!particle.newRan) {
    particle.s = randomRange(5, 3);
    particle.newRan = true;
  }

  ctx.beginPath();
  ctx.moveTo(0, particle.s);
  ctx.lineTo(particle.s / 2, 0);
  ctx.lineTo(-particle.s / 2, 0);
  ctx.lineTo(0, particle.s);
  ctx.fill();
}

const drawFns = [drawSquare, drawRect, drawCircle, drawTriangle];

function draw(this: any, ctx: CanvasRenderingContext2D) {
  if (!this.drawFn) {
    this.drawFn = drawFns[randomInt(0, drawFns.length)];
  }

  this.drawFn(this, ctx);
}

interface CompProps {
  numberOfPieces?: number;
  gravity?: number;
}

type Props = CompProps;

export const ConfettiComp: FunctionComponent<Props> = (props) => {
  const targetRef = useRef<HTMLDivElement>() as RefObject<HTMLDivElement>;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const { numberOfPieces = 500, gravity = 0.05 } = props;

  useLayoutEffect(() => {
    if (targetRef.current) {
      const currentDimensions = {
        width: targetRef.current.offsetWidth,
        height: targetRef.current.offsetHeight
      };

      if (
        dimensions.width !== currentDimensions.width &&
        dimensions.height !== currentDimensions.height
      ) {
        setDimensions(currentDimensions);
      }
    }
  }, [targetRef, dimensions.width, dimensions.height]);

  const canvasRef = useRef(null);

  return APP_CFG.showConfetti ? (
    <StyledDiv ref={targetRef}>
      <Confetti
        tweenDuration={20000}
        width={dimensions.width}
        height={dimensions.height}
        numberOfPieces={numberOfPieces}
        gravity={gravity}
        canvasRef={canvasRef}
        confettiSource={{ x: 0, y: 0, w: dimensions.width, h: 0 }}
        drawShape={draw}
        recycle={false}
      />
    </StyledDiv>
  ) : null;
};

export default ConfettiComp;
